// Lightweight customer-email store (no password, no server session).
// Set on any successful checkout so /downloads auto-loads and the site knows who's here.
const KEY = "kivo_customer_email";

export function getCustomerEmail() {
  try {
    const v = localStorage.getItem(KEY);
    return v && v.includes("@") ? v.toLowerCase() : null;
  } catch {
    return null;
  }
}

export function setCustomerEmail(email) {
  if (!email || !email.includes("@")) return;
  try {
    localStorage.setItem(KEY, email.toLowerCase());
    window.dispatchEvent(new CustomEvent("kivo:customer-change", { detail: email.toLowerCase() }));
  } catch { /* ignore */ }
}

export function clearCustomerEmail() {
  try {
    localStorage.removeItem(KEY);
    window.dispatchEvent(new CustomEvent("kivo:customer-change", { detail: null }));
  } catch { /* ignore */ }
}

export function onCustomerChange(fn) {
  const handler = (e) => fn(e.detail);
  window.addEventListener("kivo:customer-change", handler);
  return () => window.removeEventListener("kivo:customer-change", handler);
}
